// @flow
import * as React from 'react';

const withContext = (contextTypes: *) => (Comp: React.ComponentType<any>) => {
  class WithContext extends React.Component<*> {
    static contextTypes = contextTypes;
    render() {
      return <Comp {...this.props} {...this.context} />;
    }
  }

  if (process.env.NODE_ENV === 'development') {
    WithContext.displayName = `WithContext<${Comp.displayName ||
      Comp.name ||
      'unknown'}>`;
  }

  return WithContext;
};
export default withContext;



// WEBPACK FOOTER //
// ./src/utils/withContext.js